export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20vibrant%20entertainment%20news%20abstract%20background%20with%20soft%20gradients%20of%20coral%20pink%20and%20golden%20amber%2C%20stylized%20modern%20design%20with%20flowing%20organic%20shapes%2C%20subtle%20geometric%20patterns%2C%20editorial%20magazine%20aesthetic%2C%20warm%20inviting%20atmosphere%2C%20high%20quality%20digital%20art&width=1600&height=900&seq=hero-bg-51cg&orientation=landscape"
          alt="51吃瓜网站背景"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-20"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/20 to-background-50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line text-base"></i>
              全网热点实时追踪 · 每日更新
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              51吃瓜网站
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-2">
                全网最新吃瓜视频与黑料实时更新
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              51吃瓜网站作为全网最活跃的吃瓜视频聚合入口，每日追踪娱乐圈最新动态、网红黑料与综艺内幕。
              无论是51吃瓜网在线观看还是通过51吃瓜APP下载安装，这里都能让你第一时间获取今日吃瓜视频资源。
              覆盖全网最新爆料，安全直连不迷路，吃瓜就上51吃瓜网站。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-primary-500">200+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">日均更新条数</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-accent-500">7×24h</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">全天候追踪</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-secondary-500">全网覆盖</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">多平台聚合</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-chat-smile-2-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line text-lg"></i>
                51吃瓜APP下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none flex justify-center">
            <div className="relative w-full max-w-md aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20vibrant%20entertainment%20gossip%20visual%20with%20watermelon%20theme%2C%20modern%20editorial%20design%20featuring%20glowing%20neon%20social%20media%20elements%2C%20trending%20topic%20cards%2C%20coral%20pink%20and%20warm%20golden%20color%20palette%2C%20dynamic%20composition%2C%20magazine%20cover%20aesthetic%2C%20clean%20minimal%20layout%20with%20bold%20accents&width=800&height=600&seq=hero-visual-51cg&orientation=landscape"
                alt="51吃瓜网站 - 全网最新吃瓜视频与黑料实时更新"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}